<template>
  <div>
    <LoadingContainer v-if="loading"/>

    <div v-else>
      <FormPanel
          :initial="secondaryMenuLink.attributes"
          headline="Edit Secondary Menu Link"
          :errors="errors"
          @submit="submit"
      />
    </div>
  </div>
</template>

<script>
import http from '@/http'
import notify from '@/notify'
import FormPanel from '../../../../../../../components/Administration/SecondaryMenuLinks/Panels/Form'
import LoadingContainer from '../../../../../../../components/Layout/LoadingContainer'

export default {
  components: {LoadingContainer, FormPanel},

  props: {
    portal: {
      required: true
    },

    blockDrivers: {
      required: true
    },

    layoutCategories: {
      required: true
    }
  },

  data() {
    return {
      secondaryMenuLink: null,
      loading: true,

      errors: {}
    }
  },

  mounted() {
    this.load()
  },

  methods: {
    load() {
      http.get('/api/v2/secondary-menu-links/' + this.$route.params.secondaryMenuLinkId).then(response => {
        this.secondaryMenuLink = response.data.data

        this.loading = false
      })
    },

    submit(data) {
      http.put('/api/v2/secondary-menu-links/' + this.$route.params.secondaryMenuLinkId, data)
          .then(response => {
            notify.success('The secondary menu link was saved')

            this.secondaryMenuLink = response.data.data

            this.errors = {}
          })
          .catch(error => {
            if (error.response.status === 422) {
              this.errors = error.response.data.errors
            }

            throw error
          })
    },
  }
}
</script>
